<header class="header">
	<p class="main-title">
		<ng-content select="[main-title]"></ng-content>
	</p>
	<p class="sub-title">
		<ng-content  select="[sub-title]"></ng-content>
	</p>
</header>
<div class="body">
	<aside class="body-qr-part">
			<ng-content select="[aside]"></ng-content>
	</aside>
	<div class="body-main-part">
		<article class="body-main-part--content">
			<ng-content select="[article]"></ng-content>
		</article>
		<footer class="body-main-part--buttons">
			<button
					*ngFor="let button of buttons"
					tlkButton
					[variant]="button.confirm ? 'primary' : 'secondary'"
					size="l"
					(click)="close(button.matDialogClose)"
			>
				{{ button.term | translate }}
			</button>
		</footer>
	</div>
</div>
